module.exports = __webpack_public_path__ + "img/fi-rr-bowling.ce572eb3.svg";